import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import scan from 'resources/img/signup.png';
import cart from 'resources/img/cart.png';
import icon1 from 'resources/img/Group 50.png';
import banner from 'resources/img/avocado.jpg';
import { QRCodeSVG } from 'qrcode.react';
import favicon from "resources/img/favicon.ico";
import NiceModal from "@ebay/nice-modal-react";
import { useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Inline from "layouts/container/Inline";
import Center from "layouts/wrapper/Center";

import { OutletContext, SignUpQR } from "./main/WebSocketContainer";
import { useContext, useEffect, useRef } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Dummy from "components/Dummy";
import MobileHome from "./MobileHome";
import signUpSound from "resources/music/수빈.mp3";
import puffuIcon from "resources/img/puffu/puffuIconsvg.svg";
import appDownImg from "resources/img/appDownImg.svg";
import preOrderImg from "resources/img/preOrderImg.svg";
import videoFile from "resources/video/main.mp4";
import style from "./HorizontalHome.module.css";
import logo from "resources/img/puffu/puffulogo.svg";
import categorySound from "resources/music/물방울.mp3";
import { useTouchClick } from "shared/hooks/useTouchClick";
import qr from "resources/video/qr.mp4";
import { Translate } from "@mui/icons-material";
import FlipCard from "./main/vending/mainPage/card/FlipCard";


function DemoHome() {
    const { id } = useContext(OutletContext);
    const navigate = useNavigate();
    const audioRef = useRef();
    const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";
    const SignUpQR = () => {
        return (
            <div className={style.qrWrapper}>
                <QRCodeSVG
                    //  value={"puffu:action"}
                    //  value={`${window.location.origin}/ws/${id}/signUp`}
                    //  value={"puffu:MainScreen"}
                    value={`http://localhost:8080/ws/${id}/vendingSignIn?deviceCode=${deviceCode}`}
                    //  value={`http:puffuapp.com/ws/${id}/vendingSignIn?deviceCode=${deviceCode}`}
                    size={256}
                    bgColor={"transparent"}
                    //  bgColor={"#fe5b35"}
                    fgColor={"#fff"}
                    level={"L"}
                    includeMargin={true}
                // imageSettings={{
                //     src: favicon,
                //     x: undefined,
                //     y: undefined,
                //     height: 48,
                //     width: 48,
                //     excavate: true,
                // }}
                />
                <div className={style.qrCornerAnimation}>
                    <div className={style.topRightCorner}></div>
                    <div className={style.bottomLeftCorner}></div>
                </div>
            </div>
        );
    }
    const AppDownQR = () => {
        return (
            <div className={style.qrWrapper}>
                <QRCodeSVG
                    //  value={"puffu:action"}
                    //  value={`${window.location.origin}/ws/${id}/signUp`}
                    //  value={"puffu:MainScreen"}
                    value={`https://appdown.puffuapp.com`}
                    //  value={`http:puffuapp.com/ws/${id}/vendingSignIn?deviceCode=${deviceCode}`}
                    size={256}
                    bgColor={"#fff"}
                    //  bgColor={"#fe5b35"}
                    fgColor={"#000000"}
                    level={"L"}
                    includeMargin={true}
                // imageSettings={{
                //     src: favicon,
                //     x: undefined,
                //     y: undefined,
                //     height: 48,
                //     width: 48,
                //     excavate: true,
                // }}
                />
                <div className={style.qrCornerAnimationWhite}>
                    <div className={style.topRightCorner}></div>
                    <div className={style.bottomLeftCorner}></div>
                </div>
            </div>
        );
    }
    const Button = ({ background, backgroundColor, boxShadow, text, color, img, element, url, border, text2 }) => {
        const { handleTouchStart, handleTouchEnd } = useTouchClick(
            onStartClick,
            10, // threshold를 더 작은 값으로 조정
            null,
            true // stopPropagation을 true로 설정
        );
        return (
            <div
                // onMouseDown={onStartClick}

                onPointerDown={handleTouchStart}
                onPointerUp={handleTouchEnd}
                style={{ userSelect: "none", cursor: "pointer", border: border && border, borderRadius: "5px", height: "600px" }}>
                {/* <SquareWrapper width={"100%"}> */}
                <div style={{ background: background, width: "100%", height: "100%", borderRadius: "5px", backgroundColor: backgroundColor, boxShadow: `1px 1px 2.5999999046325684px 0px ${boxShadow}` }}>
                    <VerticalFlex>

                        <FlexChild height={"60%"} width={"max-content"} justifyContent={"center"}>
                            {
                                img
                                    ?
                                    <div style={{ padding: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <img src={img} width={"100%"} alt="" style={{ height: "100%", borderRadius: "20px" }} />
                                    </div>
                                    :
                                    <div style={{ padding: "30px" }}>
                                        {element}
                                    </div>
                            }
                        </FlexChild>
                        <FlexChild>
                            {/* <Center width={"100%"}> */}
                            <P color={color} size={"1.7vw"} weight={"bold"}>{text}</P>
                            <Dummy height={"15px"} />
                            <P color={color} size={"1.2vw"} weight={500}>{text2}</P>
                            {/* </Center> */}
                        </FlexChild>
                    </VerticalFlex>
                </div>
                {/* </SquareWrapper> */}
            </div>
        );
    }

    const onSignUpClick = () => {
        if (window.BRIDGE && window.BRIDGE.testAndroid) {
            window.BRIDGE.testAndroid();
        }

    }

    const onStartClick = (e) => {
        audioRef.current.play();
        navigate(`/ws/${id}/demoKiosk/main`);
    }

    const button = {
        rest: { scale: 1 },
        hover: { scale: 1.1 },
        pressed: { scale: 0.95 }
    };

    const arrow = {
        rest: { rotate: 0 },
        hover: { rotate: 360, transition: { duration: 0.4 } }
    };

    // useEffect(() => {
    //     // return audioRef.current.play();

    // }, [])




    return (

        <AnimatePresence>
            <motion.div
                className="box"
                initial={{ scale: 0.5 }}
                animate={{ scale: 1 }}
            >
                <Container height={"100vh"}>
                    <audio ref={audioRef} src={categorySound} preload="auto" />
                    <VerticalFlex>
                        <FlexChild height={"30%"}>
                            <VerticalFlex>
                                <FlexChild />
                                <FlexChild height={"max-content"}>
                                    <P size={"3vw"} weight={"bold"} color={"#FE531F"}>반가워요!</P>
                                    <P size={"2.5vw"} weight={"900"}>24시간 언제나 간편한 무인 매장 푸푸입니다!</P>

                                </FlexChild>
                                <FlexChild height={"max-content"}>
                                    <P size={"1.5vw"} color={"#797979"}>PUFFU 회원가입하고 웰컴 기프트와 할인 혜택을 받아보세요!</P>
                                </FlexChild>

                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild width={"80%"} height={"60%"}>
                            <HorizontalFlex >
                                <FlexChild width={"31%"} height={"100%"}>
                                    <FlipCard
                                        frontContent={
                                            <div style={{ position: "relative", userSelect: "none", border: "2px solid var(--point-color)", borderRadius: "5px", height: "600px" }}>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", width: "100px", top: -10, right: -10, backgroundColor: "white", padding: "5px", height: "100px" }}>

                                                    <img src={puffuIcon} />
                                                </div>
                                                <div style={{ width: "100%", height: "100%", borderRadius: "20px" }}>
                                                    <Dummy height={"70px"} />
                                                    <div style={{ padding: "20px", height: "50%", display: "flex", justifyContent: "center", alignItems: "center", transform: 'translateX(-15px)' }}>
                                                        <img src={appDownImg} width={"30%"} />
                                                    </div>

                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 'max-height' }}>
                                                        <img src={logo} width={"24%"} />
                                                        <Dummy width={"10px"} />
                                                        <P weight={900} size={"1.6vw"}> 앱 다운로드</P>
                                                    </div>
                                                    <Dummy height={"30px"} />
                                                    <P textAlign={"center"} lineHeight={"70%"} size={"1.2vw"} weight={500}>QR코드를 스캔해 어플리케이션을</P>
                                                    <P textAlign={"center"} size={"1.2vw"} weight={500}>다운로드 해주세요.</P>
                                                </div>
                                            </div>
                                        }
                                        backContent={
                                            <div style={{ position: "relative", userSelect: "none", border: "2px solid var(--point-color)", borderRadius: "5px", height: "600px" }}>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", width: "100px", top: -10, right: -10, backgroundColor: "white", padding: "5px", height: "100px" }}>
                                                    <img src={puffuIcon} />
                                                </div>
                                                <div style={{ width: "100%", height: "100%", borderRadius: "20px" }}>
                                                    <Dummy height={"70px"} />

                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <img src={logo} width={"24%"} />
                                                        <Dummy width={"10px"} />
                                                        <P weight={900} size={"1.6vw"}> 앱 다운로드</P>
                                                    </div>
                                                    <div style={{ padding: "30px", height: "60%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <AppDownQR />
                                                    </div>
                                                    <P textAlign={"center"} lineHeight={"70%"} size={"1.2vw"} weight={500}>QR코드를 스캔해 어플리케이션을</P>
                                                    <P textAlign={"center"} size={"1.2vw"} weight={500}>다운로드 해주세요.</P>
                                                </div>
                                            </div>
                                        }
                                    />

                                </FlexChild>
                                <FlexChild width={"31%"}>

                                    <motion.div
                                        className="refresh"
                                        variants={button}
                                        initial="rest"
                                        whileHover="hover"
                                        whileTap="pressed"
                                    >
                                        <Button background={"linear-gradient(180deg, #F6F8FF 0%, #EAEFFF 100%)"} boxShadow={"#00000033"} text={"상품 바로보기"} text2={"푸푸의 다양한 상품을 바로 구매해보세요!"} color={"black"} img={icon1} />
                                    </motion.div>
                                </FlexChild>
                                <FlexChild width={"31%"} height={"100%"}>
                                    <FlipCard
                                        frontContent={
                                            <div style={{ position: "relative", userSelect: "none", background: "linear-gradient(180deg, #FE531F 0%, #FF7171 100%)", borderRadius: "5px", height: "600px" }}>
                                                <div style={{ width: "100%", height: "100%", borderRadius: "20px" }}>
                                                    <Dummy height={"75px"} />
                                                    <div style={{ display: "flex", padding: "30px", justifyContent: "center", alignItems: "center", height: "50%" }}>
                                                        <img src={preOrderImg} width={"35%"} />
                                                    </div>
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#fff", width: "max-content", padding: "5px 20px" }}>
                                                            <P weight={700} size={"1.6vw"} color={"var(--main2-color)"}>푸푸오더로 미리 주문한 경우</P>
                                                        </div>
                                                    </div>
                                                    <Dummy height={"30px"} />
                                                    <P lineHeight={"70%"} textAlign={"center"} size={"1.2vw"} weight={500} color={"white"}>푸푸 어플리케이션 접속 후 QR코드 스캔</P>
                                                    <P textAlign={"center"} size={"1.2vw"} weight={500} color={"white"}>버튼을 눌러 좌측의 QR코드를 스캔해주세요.</P>

                                                </div>
                                            </div>
                                        }
                                        backContent={
                                            <div style={{ position: "relative", userSelect: "none", background: "linear-gradient(180deg, #FE531F 0%, #FF7171 100%)", borderRadius: "5px", height: "600px" }}>
                                                <div style={{ width: "100%", height: "100%", borderRadius: "20px" }}>
                                                    <Dummy height={"60px"} />
                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#fff", width: "max-content", padding: "5px 20px" }}>
                                                            <P weight={700} size={"1.6vw"} color={"var(--main2-color)"}>푸푸오더 주문 QR</P>
                                                        </div>
                                                    </div>
                                                    <div style={{ display: "flex", padding: "30px", justifyContent: "center", alignItems: "center", height: "60%" }}>
                                                        <SignUpQR />
                                                    </div>
                                                    <P lineHeight={"70%"} textAlign={"center"} size={"1.2vw"} weight={500} color={"white"}>QR코드를 스캔해 푸푸오더를 완료해주세요.</P>
                                                </div>
                                            </div>
                                        }
                                    />
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </Container>
                {/* <div
                                            style={{ overflow: "hidden", height: "430px", borderRadius: "15px" }}>
                                            <video autoPlay loop style={{ width: "100%", objectFit: "cover", height: "102%", borderRadius: "15px", border: "none" }} muted={true} >
                                                <source style={{ border: "none" }} src={qr} type="video/mp4" />
                                            </video>
                                        </div> */}
            </motion.div>
        </AnimatePresence>
    );
}

export default DemoHome;